<template>
  <v-row>
    <v-col cols="12" md="10" offset-md="1">
      <v-form v-model="mainFormValid" @input="$emit('validate', $event)">
        <v-select
          v-model="internalValue.demandId"
          :label="$t('company.addToken.fields.demand')"
          :items="demandItems"
          prepend-icon="mdi-cube-send"
          @input="onChangeDemand"
        />

        <ag-number-field
          v-model="internalValue.tokenNumber"
          :label="$t('company.addToken.fields.tokenNumber')"
          :rules="$options.rules.tokenNumber"
          prepend-icon="mdi-checkbox-multiple-marked-circle"
          @input="change"
        />

        <v-text-field
          v-model="internalValue.label"
          :label="$t('company.addToken.fields.label')"
          :rules="$options.rules.label"
          prepend-icon="mdi-label"
          type="text"
          @input="change"
        />

        <v-file-input
          :label="$t('company.addToken.fields.bill')"
          prepend-icon="mdi-file-pdf"
          @change="onUploadBill"
        />
      </v-form>
    </v-col>
  </v-row>
</template>

<script>
import Helpers from 'src/utils/helpers'
import FormRules from 'src/utils/form-rules'

import AgNumberField from 'src/components/common/AgNumberField'

export default {
  name: 'CompanyAddTokenForm',
  components: {
    AgNumberField,
  },
  props: {
    value: {
      type: Object,
      required: true,
    },
    demandList: {
      type: Array,
      default: () => ([]),
    },
  },
  data () {
    return {
      internalValue: null,
      mainFormValid: false,
    }
  },
  computed: {
    demandItems () {
      return [
        { value: '', text: this.$t('company.addToken.demandFieldEmpty') },
        ...this.demandList.map(demand => ({
          value: demand.id,
          text: this.$tc('company.addToken.demandItemLabel', demand.tokenNumber, {
            token: demand.tokenNumber,
            firstName: demand.createdBy.firstName,
            lastName: demand.createdBy.lastName,
            date: Helpers.formatDate(demand.creationDate, this.$t('date.dateAndTime')),
          }),
        })),
      ]
    },
    currentDemand () {
      return this.internalValue.demandId
        ? this.demandList.find(item => item.id === this.internalValue.demandId)
        : null
    },
  },
  watch: {
    value: {
      immediate: true,
      handler (value) {
        this.internalValue = Helpers.clone(value)
      },
    },
    'internalValue.demandId': {
      immediate: true,
      handler () {
        if (this.currentDemand) {
          this.internalValue.tokenNumber = this.currentDemand.tokenNumber
        }
      },
    },
  },
  methods: {
    change () {
      this.$emit('input', this.internalValue)
      this.$emit('validate', this.mainFormValid)
    },
    onChangeDemand (demandId) {
      const demand = this.demandList.find(item => item.id === demandId)
      if (demand) {
        this.internalValue.tokenNumber = demand.tokenNumber
      }
      this.change()
    },
    onUploadBill (file) {
      if (file) {
        this.internalValue.bill = file
        this.change()
      }
    },
  },
  rules: {
    tokenNumber: [
      FormRules.required('error.form.required'),
      FormRules.greater('error.form.greater', { number: 0 }),
      FormRules.integer('error.form.integer'),
    ],
    label: [
      FormRules.required('error.form.required'),
    ],
  },
}
</script>
